<template>

    <div class="outer-wrapper">

        <div class="inner-wrapper">

            <font-awesome-icon class="options-tab-icon" icon="cog" size="3x" />
            <div class="options-icons">

                <button @click=" toggleDownloadModal() ">
                    <font-awesome-icon class="app-option-icon" icon="download" size="3x" />
                </button>
                <button @click=" toggleRoleModal() ">
                    <font-awesome-icon class="app-option-icon" icon="user-circle" size="3x" />
                </button>
            </div>
        </div>
    </div>

</template>

<script>

    import { mapGetters } from 'vuex';
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

    // this component is not in use, moved tab options to settings page
    export default {

        name: 'options-tab',
        methods: {

            toggleDownloadModal(){

                const modalContent = {

                    type        : 'install-webapp',
                    title       : 'Save This App',
                    content     : {
                        prompt : 'you can download this webapp in one step! simply click the button below'
                    },
                    buttonTitle : 'Save',
                    showTip     : false
                };
                this.$store.dispatch( 'modal/toggleModal', modalContent );
            },
            toggleRoleModal(){

                const modalContent = {

                    type        : 'role-switch',
                    title       : 'Change Role',
                    content     : {

                    },
                    buttonTitle : 'Switch',
                    showTip     : false
                };
                this.$store.dispatch( 'modal/toggleModal', modalContent );
            }
        },
        computed: {

            ...mapGetters({

                modalOpen : 'modal/modalShowing'
            })
        },
        components: {

            FontAwesomeIcon
        }
    }
</script>

<style scoped>

    .outer-wrapper{

        position: fixed;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        background-color: transparent;
        transition: all 0.3s ease-out;
        z-index: 225;
        bottom: 75px;
        right: -23px;
        width: 60px;
    }
    .outer-wrapper:hover {

        right: -10px !important;
        width: 100%;
    }

    .inner-wrapper{

        position: relative;
        padding: 5px 5px;
        border-radius: 10px;
        display: flex;
        flex-direction: row;
        color: white;
        width: 100%;

        background-color: rgba( 0, 0, 0, 0.6 );
    }

    .options-tab-icon{

        flex: 1;
    }
    .options-icons{

        flex: 9;
        display: flex;
        padding: 0px 10px;
    }
    .options-icons > button{

        border-radius: 10px;
        margin: 0px 5px;
    }
    .app-option-icon{

        cursor: pointer;
    }

</style>